import { ArticleType } from "@/@types/BlogArticle";
import { textEllipsisOverflow } from "@/utils/common-functions";
import { otherBlogs } from "@/utils/content";
import { routes } from "@/utils/routes";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";

type OtherBlogsListProps = {
  articlesToDisplay: ArticleType[];
  searchTerm: string;
  numberOfArticles: number;
  moreArticles: () => void;
  classes: any;
};

const OtherBlogsList = ({
  articlesToDisplay,
  searchTerm,
  numberOfArticles,
  moreArticles,
  classes,
}: OtherBlogsListProps) => {
  const content = otherBlogs.en;

  return (
    <>
      <Row>
        {articlesToDisplay
          .slice(0, numberOfArticles)
          .map(({ title, date, category, id, localImageURL }, index) => (
            <Col key={index} xs={12} sm={6} md={4} lg={4}>
              <Link href={`${routes.blog}/${id}`}>
                <Card className={classes.otherCard}>
                  <Image
                    src={
                      localImageURL
                        ? localImageURL
                        : "/images/newsroom/image-na-card.png"
                    }
                    alt="blog article illustration"
                    height={200}
                    width={300}
                    style={{
                      width: "100%",
                      height: "auto",
                      minHeight: "200px",
                      maxHeight: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <CardBody>
                    <small className="date">{date}</small>
                    <br />
                    <br />
                    <p className="fw-bold">
                      {textEllipsisOverflow(title, 100)}
                    </p>
                    <small className="category">
                      {textEllipsisOverflow(
                        category ? category : content.noCategory,
                        70
                      )}
                    </small>
                  </CardBody>
                </Card>
              </Link>
            </Col>
          ))}
      </Row>
      {searchTerm && (
        <Button
          className={classes.loadmoreBtn}
          onClick={moreArticles}
          disabled={numberOfArticles >= articlesToDisplay.length}
        >
          {otherBlogs.en.viewMore}
        </Button>
      )}
      {searchTerm && articlesToDisplay.length === 0 && (
        <h6>{otherBlogs.en.noArticles}</h6>
      )}
    </>
  );
};

export default OtherBlogsList;
